import { render, staticRenderFns } from "./ChooseReportCustomComponent.vue?vue&type=template&id=640fb41b"
import script from "./ChooseReportCustomComponent.vue?vue&type=script&lang=js"
export * from "./ChooseReportCustomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports